import { Box, Tab, Tabs } from '@mui/material';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import PageLayout from '../subcomponents/PageLayout';
import MessageSendTab from './MessageSendTab';
import MessagesTab from './MessagesTab';

export default function MessagesPage() {
    const [value, setValue] = useState(0);
    const { appLanguage, resourceFinal } = useSelector((state) => state.settings.resource.resources);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <PageLayout
            title={resourceFinal[appLanguage].words.MESSAGES_PAGE}
            content={
                <>
                    <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                        <Tabs value={value} onChange={handleChange}>
                            <Tab label={`${resourceFinal[appLanguage].words.MESSAGES_PAGE} ${resourceFinal[appLanguage].words.SEND2}`} />
                            <Tab label={`${resourceFinal[appLanguage].words.SENT} ${resourceFinal[appLanguage].words.MESSAGES_PAGE}`} />
                        </Tabs>
                    </Box>
                    <TabPanel value={value} index={0}>
                        <MessageSendTab />
                    </TabPanel>
                    <TabPanel value={value} index={1}>
                        <MessagesTab />
                    </TabPanel>
                </>
            }
            bottomBar
            disableHeaderBackground
            disableContentBackground
        />
    );
};

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <Box
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
            sx={{ display: value !== index ? 'none' : 'flex', flex: '1 1 auto' }}
        >
            {value === index && (
                <Box sx={{ display: 'flex', flex: '1 1 auto', py: 1 }}>
                    {children}
                </Box>
            )}
        </Box>
    );
};
